// extracted by mini-css-extract-plugin
export default {"plain-text":"mK4W","plainText":"mK4W"};